import { useState } from 'react';
import { Link } from 'react-router-dom';
import AnimSection from '../components/AnimSection';
import ServicePhotoSlider from '../components/ServicePhotoSlider';
import { SERVICES } from '../data';

export default function Services() {
  const [open, setOpen] = useState(null);

  return (
    <div className="page-enter" style={{ paddingTop:'66px' }}>

      {/* ── PAGE HERO ─────────────────────────── */}
      <div style={{ background:'var(--page-hero-soft)', padding:'5rem clamp(1.2rem,4vw,3rem) 4rem', borderBottom:'1px solid var(--border-1)', position:'relative', overflow:'hidden' }}>
        <div className="grid-bg" style={{ position:'absolute', inset:0 }} />
        <div className="sw" style={{ position:'relative', zIndex:1 }}>
          <div className="tag" style={{ marginBottom:'1rem' }}>What We Offer</div>
          <h1 className="section-title" style={{ fontSize:'clamp(2.4rem,5vw,4rem)', marginBottom:'1rem' }}>OUR <span className="highlight">SERVICES</span></h1>
          <p style={{ color:'var(--mu)', maxWidth:'600px', lineHeight:1.8, fontSize:'1.05rem' }}>
            At Elbot Automation, we specialise in delivering tailored automation solutions designed to streamline your operations and boost productivity. Our comprehensive services cover every aspect — from initial concept through production.
          </p>
        </div>
      </div>

      {/* ── PROCESS BAR ───────────────────────── */}
      <div style={{ background:'var(--w2)', borderBottom:'1px solid var(--border-3)', padding:'1.5rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <div style={{ display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:'1rem' }}>
            {['Discovery','Design','Build','Commission','Support'].map((s,i) => (
              <div key={s} style={{ textAlign:'center', position:'relative' }}>
                <span style={{ fontFamily:'var(--fM)', fontSize:'.78rem', color:i===0?'var(--o)':'var(--mu)' }}>{i+1}. {s}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── ACCORDION SERVICES ────────────────── */}
      <div style={{ background:'var(--w3)', padding:'4rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw" style={{ display:'flex', flexDirection:'column', gap:'1.2rem' }}>
          {SERVICES.map((s,i) => (
            <AnimSection key={i} delay={i*.05}>
              <div className="card" style={{ cursor:'pointer', borderColor:open===i?'var(--accent-40)':undefined }} onClick={() => setOpen(open===i?null:i)}>

                {/* Photo */}
                <ServicePhotoSlider images={s.imgs} alt={s.title} />

                {/* Header */}
                <div style={{ padding:'1.8rem 2rem', display:'grid', gridTemplateColumns:'60px 1fr auto', gap:'1.5rem', alignItems:'center' }}>
                  <div className="icon-circle" style={{ width:'54px', height:'54px', fontSize:'1.5rem' }}>{s.icon}</div>
                  <div>
                    <div style={{ display:'flex', gap:'.6rem', flexWrap:'wrap', alignItems:'center', marginBottom:'.5rem' }}>
                      <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.4rem', letterSpacing:'1px' }}>{s.title}</h3>
                      <span className="badge" style={{ background:'var(--oL)', color:'var(--o)', border:'1px solid var(--accent-20)' }}>★ {s.highlight}</span>
                    </div>
                    <p style={{ color:'var(--mu)', fontSize:'.93rem' }}>{s.short}</p>
                    <div style={{ display:'flex', gap:'.4rem', flexWrap:'wrap', marginTop:'.7rem' }}>
                      {s.tags.map(t => <span key={t} className="chip">{t}</span>)}
                    </div>
                  </div>
                  <div style={{ display:'flex', flexDirection:'column', alignItems:'flex-end', gap:'.5rem' }}>
                    <div style={{ width:'30px', height:'30px', borderRadius:'50%', border:'1.5px solid var(--accent-30)', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--o)', fontSize:'1rem', transform:open===i?'rotate(45deg)':'none', transition:'transform .3s', background:open===i?'var(--oL)':'transparent' }}>+</div>
                  </div>
                </div>

                {/* Expanded detail */}
                {open === i && (
                  <div style={{ borderTop:'1px solid var(--border-3)', padding:'2rem', background:'var(--w3)', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'2.5rem', animation:'dropIn .3s ease' }}>
                    <div>
                      <h4 style={{ fontFamily:'var(--fH)', fontSize:'1.1rem', letterSpacing:'2px', marginBottom:'1rem' }}>OVERVIEW</h4>
                      <p style={{ color:'var(--mu)', lineHeight:1.8, fontSize:'.93rem', marginBottom:'1.5rem' }}>{s.desc}</p>
                      <div style={{ display:'flex', gap:'2rem', flexWrap:'wrap' }}>
                        <div>
                        </div>
                        <div>
                          <div style={{ fontFamily:'var(--fM)', fontSize:'.67rem', color:'var(--o)', letterSpacing:'2px', textTransform:'uppercase', marginBottom:'.3rem' }}>Industries</div>
                          <div style={{ fontFamily:'var(--fH)', fontSize:'.9rem', lineHeight:1.5 }}>{s.industries.join(' · ')}</div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h4 style={{ fontFamily:'var(--fH)', fontSize:'1.1rem', letterSpacing:'2px', marginBottom:'1rem' }}>WHAT'S INCLUDED</h4>
                      {s.features.map((f,fi) => (
                        <div key={fi} className="check-feature">
                          <div className="check-icon">✓</div>
                          <span style={{ color:'var(--d3)', fontSize:'.9rem', lineHeight:1.65 }}>{f}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </AnimSection>
          ))}
        </div>
      </div>

      {/* ── WHY ELBOT ─────────────────────────── */}
      <div style={{ background:'var(--w2)', padding:'5rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <AnimSection style={{ textAlign:'center', marginBottom:'3rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>Why Choose Elbot</div>
            <h2 className="section-title">THE <span className="highlight">ELBOT</span> DIFFERENCE</h2>
            <div className="divider" style={{ margin:'1rem auto 0' }} />
          </AnimSection>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'1.5rem', marginBottom:'3rem' }}>
            {[
              { icon:'🎓', t:'Certified Engineers', d:'Experienced industrial automation specialists on every project.' },
              { icon:'📋', t:'Fixed-Price Contracts', d:'No surprise invoices. Clear scope, clear price, clear delivery date — guaranteed.' },
              { icon:'🔄', t:'12-Month Warranty', d:'All systems include 12 months warranty covering hardware and software faults.' },
              { icon:'🌐', t:'Global Standards', d:'IEC, UL, CE, and ISO compliance built into every solution we deliver.' },
            ].map((c,i) => (
              <AnimSection key={i} delay={i*.08}>
                <div className="card" style={{ padding:'2rem' }}>
                  <div style={{ fontSize:'2rem', marginBottom:'1rem' }}>{c.icon}</div>
                  <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.1rem', letterSpacing:'1px', marginBottom:'.6rem' }}>{c.t}</h3>
                  <p style={{ color:'var(--mu)', fontSize:'.88rem', lineHeight:1.7 }}>{c.d}</p>
                </div>
              </AnimSection>
            ))}
          </div>

          <AnimSection style={{ textAlign:'center' }}>
            <p style={{ color:'var(--mu)', maxWidth:'520px', margin:'0 auto 2rem', lineHeight:1.8 }}>
              Ready to elevate your operations? Contact us to discover how Elbot Automation can assist in achieving your industrial automation and panel design goals.
            </p>
            <Link to="/contact" className="btn-primary" style={{ fontSize:'1.1rem', padding:'15px 36px' }}>Start a Project →</Link>
          </AnimSection>
        </div>
      </div>

    </div>
  );
}
